var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCloseWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6037 11.5L17.7714 15.6677C18.0762 15.9725 18.0762 16.4666 17.7714 16.7714C17.4666 17.0762 16.9725 17.0762 16.6677 16.7714L12.5 12.6037L8.33228 16.7714C8.0275 17.0762 7.53336 17.0762 7.22858 16.7714C6.9238 16.4666 6.9238 15.9725 7.22858 15.6677L11.3963 11.5L7.22858 7.33227C6.9238 7.02749 6.9238 6.53335 7.22858 6.22857C7.53336 5.92379 8.0275 5.92379 8.33228 6.22857L12.5 10.3963L16.6677 6.22858C16.9725 5.92381 17.4666 5.92381 17.7714 6.22858C18.0762 6.53336 18.0762 7.0275 17.7714 7.33228L13.6037 11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseWhite);
export default __webpack_public_path__ + "static/media/ic_close_white.a0f8164bd9ccc4bb7262fa11e7160c3e.svg";
export { ForwardRef as ReactComponent };